// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e714295e","833":"734cff1e"}[chunkId] + ".chunk.js";
};